import { render } from "./BarcodeProductComponent.vue?vue&type=template&id=13978598"
import script from "./BarcodeProductComponent.vue?vue&type=script&lang=js"
export * from "./BarcodeProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pos/BarcodeProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13978598"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13978598', __exports__)) {
    api.reload('13978598', __exports__)
  }
  
  module.hot.accept("./BarcodeProductComponent.vue?vue&type=template&id=13978598", () => {
    api.rerender('13978598', render)
  })

}


export default __exports__